import { bankUserViews, bankAdminViews } from "../../data";

/**
 *
 * @param {Array} allowedViews extra allowed views
 * @param {Array} blocked blocked views
 * @param {*} fullMenu
 * @returns
 */
const getMainMenu = (allowedViews, blocked, userType, fullMenu) => {
  const finalMenu = [];

  const allowedViewsHashMap = {};

  allowedViews.forEach((item) => {
    allowedViewsHashMap[item] = true;
  });

  if (userType === "bank-admin") {
    Object.values(bankAdminViews).forEach((item) => {
      allowedViewsHashMap[item] = true;
    });
  } else if (userType === "bank-user") {
    Object.values(bankUserViews).forEach((item) => {
      allowedViewsHashMap[item] = true;
    });
  }

  blocked.forEach((item) => {
    allowedViewsHashMap[item] = false;
  });

  fullMenu.forEach((item) => {
    if (allowedViewsHashMap[item.id]) finalMenu.push(item);
  });

  return finalMenu;
};

export default getMainMenu;
